
// iit_indore/Cutoff.jsx
import React from "react";
const Cutoff = () => {
  const sectionStyle = {
    padding: "20px",
    paddingTop: "0px",
    backgroundColor: "#ffffff",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    textAlign: "justify",
    overflowX: "hidden",
  };
  const tableStyle = {
    width: "80%",
    borderCollapse: "collapse",
    margin: "0 auto",
    marginBottom: "auto",
    border: "1px solid #ddd",
    fontSize: "1.2rem",
  };

  const tdStyle = {
    backgroundColor: "#f2f2f2",
    padding: "8px",
    border: "1px solid #ddd",
    fontSize: "16px",
    lineHeight: "1.6",
  };

  const thStyle = {
    backgroundColor: "#1d2f52",
    color: "#fff",
    textAlign: "left",
    padding: "8px",
    fontSize: "16px",
    lineHeight: "1.6",
  };

  const pStyle = {
    fontSize: "16px",
    lineHeight: "1.6",
  };

  const h2Style = {
    color: "rgb(0,0,255)",
    fontSize: "32px",
    fontWeight: "700",
    textAlign: "center",
    lineHeight: "48px",
  };

  const th3Style = {
    marginLeft: "5%",
    fontSize: "20px",
    fontWeight: "700",
  };
  return (
<section id="cutoff">
      <h2 style={h2Style}>Cutoff</h2>
      <p id="gen" style = {pStyle}>IIT Indore cutoff 2024 has been concluded for admission to the UG and PG
        courses. This year, a total of 5 rounds of JoSAA counselling were
        conducted for IITs. IIT Indore JEE Advanced cutoff 2024 was released as
        opening and closing ranks for General, OBC, SC, ST, EWS, and PWD
        categories under the AI quota.</p>
      <table style={tableStyle}>
      <thead>
        <tr>
          <th style={thStyle}>Course</th>
          <th style={thStyle}>R1 (Closing Rank)</th>
          <th style={thStyle}>Last Round (Closing Rank)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={tdStyle}>B.Tech. in Chemical Engineering</td>
          <td style={tdStyle}>7489</td>
          <td style={tdStyle}>7913</td>
        </tr>
        <tr>
          <td style={tdStyle}>B.Tech. in Civil Engineering</td>
          <td style={tdStyle}>9255</td>
          <td style={tdStyle}>9773</td>
        </tr>
        <tr>
          <td style={tdStyle}>B.Tech. in Computer Science and Engineering</td>
          <td style={tdStyle}>1354</td>
          <td style={tdStyle}>1389</td>
        </tr>
        <tr>
          <td style={tdStyle}>B.Tech. in Electrical Engineering</td>
          <td style={tdStyle}>3498</td>
          <td style={tdStyle}>3818</td>
        </tr>
        <tr>
          <td style={tdStyle}>B.Tech. in Engineering Physics</td>
          <td style={tdStyle}>6814</td>
          <td style={tdStyle}>7612</td>
        </tr>
        <tr>
          <td style={tdStyle}>B.Tech. in Mathematics and Computing</td>
          <td style={tdStyle}>2074</td>
          <td style={tdStyle}>2180</td>
        </tr>
        <tr>
          <td style={tdStyle}>B.Tech. in Mechanical Engineering</td>
          <td style={tdStyle}>6139</td>
          <td style={tdStyle}>6812</td>
        </tr>
        <tr>
          <td style={tdStyle}>B.Tech. in Metallurgical Engineering and Materials Science</td>
          <td style={tdStyle}>10094</td>
          <td style={tdStyle}>10894</td>
        </tr>
        <tr>
          <td style={tdStyle}>B.Tech. in Space Sciences and Engineering</td>
          <td style={tdStyle}>6362</td>
          <td style={tdStyle}>6640</td>
        </tr>
      </tbody>
    </table>

    <p style = {pStyle}>IIT Indore JEE Advanced Cutoff Year Wise Comparison 2024, 2023, 2022
JEE Advanced Last Round Closing Rank (General-All India) 
    </p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Course</th>
            <th style={thStyle}>2022</th>
            <th style={thStyle}>2023</th>
            <th style={thStyle}>2024</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>B.Tech. in Computer Science and Engineering</td>
            <td style={tdStyle}>1204</td>
            <td style={tdStyle}>1385</td>
            <td style={tdStyle}>1389</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Electrical Engineering</td>
            <td style={tdStyle}>3828</td>
            <td style={tdStyle}>3632</td>
            <td style={tdStyle}>3818</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Mechanical Engineering</td>
            <td style={tdStyle}>7509</td>
            <td style={tdStyle}>7474</td>
            <td style={tdStyle}>6812</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Civil Engineering</td>
            <td style={tdStyle}>10568</td>
            <td style={tdStyle}>10994</td>
            <td style={tdStyle}>9773</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Metallurgical Engineering and Materials Science</td>
            <td style={tdStyle}>11310</td>
            <td style={tdStyle}>12217</td>
            <td style={tdStyle}>10894</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Chemical Engineering</td>
            <td style={tdStyle}>-/-</td>
            <td style={tdStyle}>9658</td>
            <td style={tdStyle}>7913</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Engineering Physics</td>
            <td style={tdStyle}>-/-</td>
            <td style={tdStyle}>8205</td>
            <td style={tdStyle}>8205</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Space Sciences and Engineering</td>
            <td style={tdStyle}>-/-</td>
            <td style={tdStyle}>7821</td>
            <td style={tdStyle}>6640</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Mathematics and Computing</td>
            <td style={tdStyle}>-/-</td>
            <td style={tdStyle}>2209</td>
            <td style={tdStyle}>2180</td>
          </tr>
        </tbody>
      </table>

      <p style = {pStyle}>JEE Advanced Last Round Closing Rank (OBC-All India)</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Course</th>
            <th style={thStyle}>2022</th>
            <th style={thStyle}>2023</th>
            <th style={thStyle}>2024</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>B.Tech. in Computer Science and Engineering</td>
            <td style={tdStyle}>537</td>
            <td style={tdStyle}>448</td>
            <td style={tdStyle}>649</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Electrical Engineering</td>
            <td style={tdStyle}>1613</td>
            <td style={tdStyle}>1820</td>
            <td style={tdStyle}>1648</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Mechanical Engineering</td>
            <td style={tdStyle}>2959</td>
            <td style={tdStyle}>3217</td>
            <td style={tdStyle}>2993</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Civil Engineering</td>
            <td style={tdStyle}>3569</td>
            <td style={tdStyle}>4204</td>
            <td style={tdStyle}>3974</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Metallurgical Engineering and Materials Science</td>
            <td style={tdStyle}>4105</td>
            <td style={tdStyle}>4684</td>
            <td style={tdStyle}>4524</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Chemical Engineering</td>
            <td style={tdStyle}>-/-</td>
            <td style={tdStyle}>4245</td>
            <td style={tdStyle}>3568</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Engineering Physics</td>
            <td style={tdStyle}>-/-</td>
            <td style={tdStyle}>4196</td>
            <td style={tdStyle}>3618</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Space Sciences and Engineering</td>
            <td style={tdStyle}>-/-</td>
            <td style={tdStyle}>3492</td>
            <td style={tdStyle}>3159</td>
          </tr>
          <tr>
            <td style={tdStyle}>B.Tech. in Mathematics and Computing</td>
            <td style={tdStyle}>-/-</td>
            <td style={tdStyle}>1319</td>
            <td style={tdStyle}>1064</td>
          </tr>
        </tbody>
      </table>
      </section>

      );
    };
    
export default Cutoff;